import React                    from 'react';
import { withRouter }           from 'react-router';
import { Link }                 from "react-router-dom";
import { connect }              from 'react-redux';
import { ClipLoader }           from 'react-spinners';
import { Table }                from 'react-bootstrap';
import { Badge }                from 'react-bootstrap';
import CatalogBreadcrumb        from './Breadcrumb';
import { AwsConstants }         from '../../../utils/environment';
import { searchFetchData }      from '../../../actions/catalog/search';
import { categoriesFetchData }  from '../../../actions/catalog/categories';
import { isLoggedIn }           from '../../../utils/authService';
import Login                    from '../../Login';

var apiHost = AwsConstants.WebApiHost;

class Search extends React.Component {
    
  search() {
    var search = this.props.location.pathname.replace(/^\/search\//, '');  
    return search;
  }
    
  category() {
    var search   = this.search();
    var category = '';  
    if (search.includes('category/')) {
      category = search.split('/')[1];
    }
    
    return category;
  }
  
  sub() {
    var search = this.search();
    var sub    = '';
    if (search.includes('category/') && search.includes('/sub/')) {
      sub = search.split('/')[3];
    }
    
    return sub;
  }

  componentDidMount() {
    var category = this.category();
    var sub      = this.sub();
    var search   = this.search();
    if (category || sub) {
      search = '';
    }
    
    if (this.props.location.pathname.startsWith('/search')) {
      this.props.fetchSearchData(apiHost, search, category, sub);
      this.props.fetchCategoryData(apiHost);
    }
  }
  
  componentWillUnmount() { 
    if (this.props.search.items) {
      this.props.search.items.length = 0;
    }
  }

  render() {
    var category = this.props.categories ? this.props.categories.find(o => o.name === this.category()) : null;    
    return (
      <div>
        <CatalogBreadcrumb {...this.props} />
        {category && category.sub && category.sub.length > 0 ?
          <aside className="col-sm-4">
            <p>Filter</p>
            <div className="card">
              <article className="card-group-item">
                <header className="card-header">
                  <h6 className="title">Similar category</h6>
                </header>
                <div className="filter-content">
                  <div className="list-group list-group-flush">
                    {category.sub.map((element, index) => (
                      <Link to={element.path ? element.path : '/search/category/' + this.category() + '/sub/' + element.name} className='list-group-item' key={index}>
                        {element.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </article>
            </div>
          </aside>
          :
          <div></div>
        }
        { this.props.searchIsLoading ?
          <div style={{ marginTop: '10px', marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
            <ClipLoader
              color={'#072659'} 
              loading={this.props.searchIsLoading} 
            />
          </div>
          :
          <div>
            <Table responsive style={{borderTop: 'none'}}>
              <thead>
                <tr>
                  <th>results <Badge>{this.props.search.length}</Badge></th>
                </tr>
              </thead>
              <tbody>
                  {this.props.search && this.props.search.map((element, index) => (
                  <tr key={index}>
                    <td>
                      <Link to={element.path ? element.path : '/result/' + this.search() + '/' + element.Id}>
                        <h2>{element.name}</h2>
                      </Link>
                      <span>{element.description}</span>
                    </td>
                  </tr>
                ))}
                {this.props.search.length === 0 && !isLoggedIn() ?
                  <div>
                    <span style={{ marginLeft: '8px' }}>Try logging in to see more results.</span>
                    <Login />
                  </div>
                  :
                  <span></span>
                }
              </tbody>
            </Table>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    search: state.catalog.search.search,
    searchHasErrored: state.catalog.search.searchHasErrored,
    searchIsLoading: state.catalog.search.searchIsLoading,
    categories: state.catalog.categories.categories,
    categoriesHasErrored: state.catalog.categories.categoriesHasErrored,
    categoriesIsLoading: state.catalog.categories.categoriesIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSearchData:   (host, search, category, sub) => dispatch(searchFetchData(host, search, category, sub)),
    fetchCategoryData: (host) => dispatch(categoriesFetchData(host))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Search));
